export default function InfoPopup({ text, className }) {

  const classNameUsed = className ? className : "relative inline-block my-1";
  return (
    <>
      <div className={classNameUsed}>
        <img className="popup relative -right-4 -top-[30%]" src="/assets/icons/info.svg" alt="" />
        <div className="content text-[13px] bg-[#707070] text-white normal-case min-w-full w-24 px-4 py-3 absolute rounded-lg rounded-lg">
            {text}
        </div>
    </div>
    </>
  );
}
